<template>
  <div>
    <div class="card">
      <div class="card-header">
        Contratos
        <span class="pull-right">{{ $store.state.contracts.items.length }} / {{ $store.state.contracts.total }} items</span>
      </div>
      <div class="card-body">
        <b-row>
          <b-col md="auto" class="pr-1">
            <div v-if="canAddContract">
              <b-button variant="primary" @click="openModal()">
                <i class="fa fa-plus"></i> Adicionar
              </b-button>
            </div>
          </b-col>
          <b-col class="pl-1">
            <b-form-input v-model="search" placeholder="Busca..." class="mb-2"></b-form-input>
          </b-col>
          <b-col sm="auto">
            <span class="badge badge-success" @click="filter='active'">Ativo ({{ $store.state.contracts.active }})</span>
            <span class="badge badge-danger" @click="filter='inactive'" style="margin-left: 5px;">Inativo ({{ $store.state.contracts.inactive }})</span>
            <a href="#" style="margin-left: 5px;" @click.prevent="filter='all'">Todos</a>
          </b-col>
        </b-row>
        <table class="table table-striped">
          <thead>
            <tr>
              <th v-for="item in headers" :key="item.label">{{ item.label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in sortedContracts" :key="item.pk">
              <td>
                <span class="badge badge-style" :class="item.contract_type | class_contract_type">{{ item.versions[0].contract_type_display | titleCase }}</span>
              </td>
              <td>
<!--                <span class="badge badge-style" :class="item.contract_type | class_contract_type">{{ item.contract_type_display }}</span>-->
                <div>{{ item.customer }}</div>
              </td>
              <td>
                <!-- item.versions.length - 1 -->
                <router-link :to="'/contracts/' + item.pk">{{ item.str }} {{display_readjustment_alert(item.versions[0].date_of_readjustment)}}</router-link>
              </td>
              <td :class="item.currency_money | class_currency_money" style="width: 12%">
                {{ currency_moneys.find(c => c.value == item.currency_money).icon }} <span class="pull-right">
                  <span>{{ item.versions[0].value | formatPrice }}</span>
                </span>
              </td>
              <td style="width: 80px">
                <span class="span-is-link badge badge-success border-0" :class="item.active ? 'badge-success' : 'badge-danger'" @click="toggleContractStatus(item)">{{ item.active ? 'Ativo' : 'Inativo' }}</span>
                <!-- <span class="span-is-link span-color-link float-right">
                  <i v-if="canEditContract" class="fa fa-pencil-square-o" @click="editItem(item)"></i>
                  <i v-if="canDeleteContract" class="fa fa-trash trash-color ml-3" @click="deleteItem(item)"></i>
                </span> -->
              </td>
            </tr>
          </tbody>
        </table>
        <div style="text-align: right;">
          <b-pagination :total-rows="$store.state.contracts.total" :per-page="$store.state.contracts.perPage" v-model="currentPage" style="display: inline-flex;"></b-pagination>
        </div>
        <contract-modal :editing-item="editingItem" :is-visible="isVisible" :namespace="namespace" @clear-modal="clearModal" @success-response="successResponse"></contract-modal>
      </div>
    </div>
  </div>
</template>
<script>
import ContractModal from './ContractModal';

export default {
  components: {
    ContractModal,
  },
  data() {
    return {
      allItems: [],
      namespace: 'contracts',
      headers: [
        { label: 'Tipo' },
        { label: 'Cliente' },
        { label: 'Contrato'},
        { label: 'Valor' },
        { label: 'Status' },
      ],
      isVisible: false,
      currency_moneys: [
        { value: 'r', text: 'Real', icon: 'R$' },
        { value: 'd', text: 'Dólar', icon: '$' },
        { value: 'e', text: 'Euro', icon: '€' },
      ],
      editingItem: {},
      defaultEditing: {
        contract_type: 'm',
        currency_money: 'r',
        index_of_readjustment: 1,
        index_type: 'IGPM',
        value: '',
        payment_type: 'm',
        active: true,
      },
      search: '',
      searchFields: ['title'],
      filter: 'active',
      currentPage: 1,
    };
  },
  mounted() {
    this.editingItem = { ...this.defaultEditing };
    // const savedPage = sessionStorage.getItem(`currentPage-${this.namespace}`);
    // this.currentPage = savedPage ? parseInt(savedPage, 10) : 1;

    this.$store.dispatch('contracts/loadItems', {
      search: '',
      filter: this.filter,
      page: this.currentPage
    })
    // Carrega funcionários?
    // this.$store.dispatch('financial/loadCostCenters');
  },
  computed: {
    sortedContracts() {
      return this.$store.state.contracts.items.sort((a, b) => a.customer.localeCompare(b.customer));
    },
    canAddContract() {
      return this.$store.state.auth.user.permission_codes.includes('add_contract');
    },
    canEditContract() {
      return this.$store.state.auth.user.permission_codes.includes('change_contract');
    },
    canDeleteContract() {
      return this.$store.state.auth.user.permission_codes.includes('delete_contract');
    },
  },
  watch: {
    currentPage() {
      // sessionStorage.setItem(`currentPage-${this.namespace}`, page);
      this.$store.dispatch('contracts/loadItems', {
        search: this.search,
        filter: this.filter,
        page: this.currentPage
      });
    },
    search(newVal) {
      if (newVal.length < 3 && newVal.length != 0) {
        return;
      }

      this.$store.dispatch('contracts/loadItems', {
        search: newVal,
        filter: this.filter,
        page: 1
      });
    },
    filter(filter) {
      this.$store.dispatch(this.namespace + '/loadItems', {
        search: this.search,
        filter: filter,
        page: this.currentPage
      });
    },
  },
  methods: {
    loadContracts() {
      this.$store.dispatch('contracts/loadItems', {
      search: '',
      filter: this.filter,
      page: this.currentPage
    })
    },
    toggleContractStatus(item) {
      const contractPk = item.pk;
      this.$swal.fire({
        title: item.active ? 'Inativar contrato' : 'Ativar contrato',
        text: item.active ? 'Deseja realmente inativar esse contrato?' : 'Deseja realmente ativar esse contrato?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
           this.$store.dispatch('contracts/toggleContractStatus', contractPk);
        }
      });
    },
    display_readjustment_alert(date_of_readjustment) {
      if (date_of_readjustment) {
        const date = new Date(date_of_readjustment);
        const now = new Date();
        const diff = date - now;
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));

        return days < 0 ? '- ⚠️ Reajuste atrasado' : days < 30 ? '- ⚠️ Reajuste necessário' : '';
      }
    },
    clearModal() {
      this.editingItem = { ...this.defaultEditing };
      this.isVisible = false;
    },
    openModal(data) {
      this.$emit('open-modal', data);

      this.isVisible = true;
    },
    editItem(item) {
      this.$emit('open-modal', item);
      this.isVisible = true;
      this.editingItem = { ...item };
    },
    deleteItem(item) {
      this.$swal.fire({
        title: 'Deletar item',
        text: 'Deseja realmente apagar esse item?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('contracts/deleteItem', item);
        }
      });
    },
    successResponse() {
      this.$store.dispatch('contracts/loadItems');
    },
  },
  filters: {
    titleCase(value) {
      if (!value) return ''
      value = value.toString()
      return value.replace(/\w\S*/g, function(txt){
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    class_contract_type(value) {
      /*const cl_type = {
        //'h': 'badge-success',
        'h': 'contract_badge',
        'm': 'badge-warning',
        'f': 'badge-info',
      }*/
      return 'contract_badge';
    },
    class_currency_money(value) {
      const cl_money = {
        'e': 'euro',
        'd': 'dollar',
      }
      return cl_money[value]
    }
  }
}

</script>
<style scoped>
.badge-style {
  border-radius: 8px;
  padding: .75rem;
}

.contract_badge {
  background-color: transparent;
  color: #111;
}

.euro {
  background-color: Gold;
}

.dollar {
  background-color: LightGreen;
}

</style>
